import { NormalText } from "components";
import {
  actionFormValue,
  actionInputName,
} from "components/action-modal/utils/inputName";
import { TASK_INPUT_NAMES } from "constants/action-form";
import { FormTextInput } from "form";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

/**
 *
 * @param {Object} props
 * @param {import("constants/actions").Task} props.task - The specific task for which the description input is being rendered (e.g., "fertilize"). This is used to construct the input name and retrieve the corresponding value from Formik's context.
 * @param {boolean} props.isProposed - Indicates whether the value is for a proposed action, affecting the input name construction.
 * @param {boolean} props.isViewMode - Determines if the input should be rendered in view mode, which typically disables editing and may change the appearance.
 * @returns {JSX.Element} A FormTextInput component for the action description, or a NormalText component indicating no description if in view mode and the description is empty. The input name is constructed based on the task and proposed status, and the value is retrieved from Formik's context.
 */
const ActionDescriptionInput = ({ task, isViewMode, isProposed }) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();
  const taskInputName = TASK_INPUT_NAMES[task];

  const fieldName = actionInputName(taskInputName, "description", isProposed);

  const value = actionFormValue(
    values,
    taskInputName,
    "description",
    isProposed,
  );

  const isViewingEmpty = isViewMode && !value;

  return isViewingEmpty ? (
    <NormalText sx={{ marginLeft: "20px", fontStyle: "italic" }}>
      {t("ActionModal.Description.No")}
    </NormalText>
  ) : (
    <FormTextInput
      name={fieldName}
      placeholder={t("ActionModal.Description.Placeholder")}
      shouldHaveErrorBehaviorAfterSubmit
      isMultiline
      isViewMode={isViewMode}
    />
  );
};

export default ActionDescriptionInput;
